export default "__VITE_ASSET__COU5n651__"